import Termination from "../../../../components/company/workforce/termination";

export default function TerminationPage(){
    return <Termination />
}